import "./Navbar.css";
import star from "../../assets/star.gif";
import { Link } from "react-router-dom";

export default function Navbar() {
    return (
        <nav className="navbar">
            <span className="navHeader">
                <img className="navStar" src={star} alt="purple glowing star" />
                <h1>grace's blog</h1>
                <img className="navStar" src={star} alt="purple glowing star" />
            </span>
            <ul className="navItems">
                <li>
                    <Link to="/">home</Link>
                </li>
                <li>
                    <Link to="/posts">posts</Link>
                </li>
                <li>
                    <Link to="/tags">browse by tags</Link>
                </li>
            </ul>
        </nav>
    );
}
